import { useEffect, useState } from 'react';
import axios from 'axios';

const baseURL = process.env.REACT_APP_BACKEND_API_URL || '';

// Public-folder fallbacks. Used when Strapi is unreachable, returns no items,
// or returns an item without a populated `pdf` relation. Investors should
// never see a broken link.
const FALLBACK = {
    presentationUrl: '/Q-Gold_Deck_Aug_2025a.pdf',
    factsheetUrl: '/q-gold-fact-sheet-apr-2026.pdf',
    miningForumUrl: '/qgold-mining-forum-americas-september-2026.pdf',
    presentationUpdatedAt: null,
    factsheetUpdatedAt: null,
};

let cachedPromise = null;

function fetchOnce() {
    if (!cachedPromise) {
        cachedPromise = axios
            .get(`${baseURL}/api/presentations?populate=*`)
            .then((res) => res.data?.data || [])
            .catch((err) => {
                console.error('Error fetching presentations:', err);
                cachedPromise = null;
                return [];
            });
    }
    return cachedPromise;
}

export default function usePresentations() {
    const [data, setData] = useState({ ...FALLBACK, loading: true });

    useEffect(() => {
        let cancelled = false;

        fetchOnce().then((items) => {
            if (cancelled) return;

            const presentation = items[0];
            const factsheet = items[1];

            const presentationUrl = presentation?.pdf?.url
                ? `${baseURL}${presentation.pdf.url}`
                : FALLBACK.presentationUrl;

            const factsheetUrl = factsheet?.pdf?.url
                ? `${baseURL}${factsheet.pdf.url}`
                : FALLBACK.factsheetUrl;

            setData({
                presentationUrl,
                factsheetUrl,
                miningForumUrl: FALLBACK.miningForumUrl,
                presentationUpdatedAt: presentation?.updatedAt || null,
                factsheetUpdatedAt: factsheet?.updatedAt || null,
                loading: false,
            });
        });

        return () => {
            cancelled = true;
        };
    }, []);

    return data;
}
